export default "__VITE_ASSET__DNwAe4hq__"